import { FC } from 'react'
import { TableCard } from '../../../../../components/Table/TableCard'
import { ComparacaoConteudo } from '../../components/ComparacaoConteudo'
import { ModeloPlataformaComparacaoHeading } from './components/ModeloPlataformaComparacaoHeading'
import { ModeloPlataformaComparacaoHeader } from './components/header/ModeloPlataformaComparacaoHeader'
import { useComparacaoModelo } from './core/useComparacaoModelo'

/** Comparação entre versões do modelo da plataforma (padrão: contra a publicada). */
export const ModeloPlataformaComparacaoPage: FC = () => {
  const { idVersao, versao, outrasVersoes, comparacao, catalogo, com, setCom } =
    useComparacaoModelo()

  return (
    <>
      <ModeloPlataformaComparacaoHeading versao={versao} idVersao={idVersao} />
      <TableCard>
        <ModeloPlataformaComparacaoHeader
          outrasVersoes={outrasVersoes}
          com={com}
          onChange={setCom}
        />
        <ComparacaoConteudo comparacao={comparacao} catalogo={catalogo} />
      </TableCard>
    </>
  )
}
